import router from '../router'
import { userStore } from '../stores/user'

router.beforeEach(async (to, from, next) => {
  const store = userStore()

  // Esperar a que el store esté inicializado
  await store.ensureInitialized()

  // Ahora hacer las validaciones
  if (store.isAuthenticated && to.name === 'login') {
    return next('/history')
  }

  if (to.meta.requiresAuth && !store.isAuthenticated) {
    return next({ name: 'login' })
  }

  next()
})
